import { Button } from 'AWS-UI-Components-React';
import React from 'react';

import { HeaderButtonsAlign } from '../../styles/common_styles';
import { AccuracyButton } from '../buttons/accuracy_button';
import { MarketplaceItems, Months, Years } from '../const/dropdown_elements';

import { getJSClient } from '../js_client';

export const defaultPayload = {
  region: '',
  marketplaceId: '',
  month: '',
  year: '',
  marketplace: null,
};

export class QsParameters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      payload: Object.assign({}, defaultPayload),
      clientLoaded: false,
      formSubmitted: false,
      formLoaded: false,
      productGroupsLoaded: false,
      reportDownloading: false,
      reportDownloaded: false,
      reportDownloadError: false,
      user: '',
      access: true,
    };
  }

  setRegion = (chosen) => {
    const newPayload = Object.assign({}, this.state.payload);
    newPayload.region = chosen.detail.selectedId;
    this.setState({ payload: newPayload, formSubmitted: false });
  };

  setMarketplace = (chosen) => {
    const newPayload = Object.assign({}, this.state.payload);
    newPayload.marketplaceId = chosen.detail.selectedId;
    newPayload.marketplace = parseInt(chosen.detail.selectedId, 10);
    this.setState({ payload: newPayload, formSubmitted: false });
  };

  setMonth = (chosen) => {
    const newPayload = Object.assign({}, this.state.payload);
    newPayload.month = chosen.detail.selectedId;
    this.setState({ payload: newPayload, formSubmitted: false });
  };

  setYear = (chosen) => {
    const newPayload = Object.assign({}, this.state.payload);
    newPayload.year = chosen.detail.selectedId;
    this.setState({ payload: newPayload, formSubmitted: false });
  };

  componentDidMount = () => {
    this.client = getJSClient();
    this.initialClientTasks();
  };

  initialClientTasks = () => {
    this.getUserIdentity();
  };

  getUserIdentity = () => {
    console.log('Authenticating User...');
    if (this.props.identity) {
      this.setState({ user: this.props.identity.username, clientLoaded: true });
      console.log(`Authenticated user as ${this.state.user}`);
    } else {
      console.log('No user identity found. Restricting access.');
      this.setState({ access: false });
    }
  };

  submitForm = () => {
    this.props.callback(this.state.payload);
    this.setState({ formSubmitted: true });
    console.log('Form submitted!');
  };

  clearForm = () => {
    this.setState({ payload: Object.assign({}, defaultPayload) });
    this.props.resetFunction();
  };

  render() {
    return (
      <div>
        <AccuracyButton
          text="Marketplace"
          items={MarketplaceItems}
          onChange={this.setMarketplace}
          selected={this.state.payload.marketplaceId}
          disabled={!this.state.access}
        />

        <AccuracyButton
          text="Month"
          items={Months}
          onChange={this.setMonth}
          selected={this.state.payload.month}
          disabled={!this.state.access}
        />
        <AccuracyButton
          text="Year"
          items={Years}
          onChange={this.setYear}
          selected={this.state.payload.year}
          disabled={!this.state.access}
        />

        <div className={HeaderButtonsAlign}>
          <Button text="Clear" variant="normal" onClick={this.clearForm} disabled={!this.state.access} />
          <Button text="Submit" variant="primary" onClick={this.submitForm} disabled={!this.state.access} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/navigation/qs_parameters.jsx